import { render, staticRenderFns } from "./EditSongDetailsModal.vue?vue&type=template&id=38bf5f3e&scoped=true"
import script from "./EditSongDetailsModal.vue?vue&type=script&lang=ts"
export * from "./EditSongDetailsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf5f3e",
  null
  
)

export default component.exports